export const GET_DIAMOND_RAIN_HISTORY = "GET_DIAMOND_RAIN_HISTORY";
export const GET_DIAMOND_RAIN_STATS = "GET_DIAMOND_RAIN_STATS";
